import React from 'react';
import { usePortalLanguage } from '../../../contexts/PortalLanguageContext';

// Client portal is light-mode only — render a single logo (no dark-mode <source>).
function WorkspaceLogo({ branding, fallbackSrc = '/images/keyflow-logo.generated.svg', className = 'h-12' }) {
    const { t } = usePortalLanguage();
    const { logoUrl = '', workspaceName = '' } = branding || {};
    const src = logoUrl || fallbackSrc;
    if (!src) {
        return <span className="text-xl font-semibold text-[color:var(--text-primary)]">{workspaceName}</span>;
    }
    return <img src={src} alt={workspaceName || t('Workspace logo')} className={className} />;
}

export default WorkspaceLogo;
